import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// styles
import styles from './styles.module.scss';
// types
import { IEventCheckinType } from '@/components/landing-page-templates/ConfigLandingPage/types';
//component
import {
  ILandingPageButtonStyle,
} from '@/components/landing-page-templates/ConfigLandingPage/types';
import BeforeEventSection from '@/components/landing-page-templates/ConfigLandingPage/DisplayMessageComponents/BeforeEventSection';
import AfterEventSection from '@/components/landing-page-templates/ConfigLandingPage/DisplayMessageComponents/AfterEventSection';
import EnterEventConfirmationSection from '@/components/landing-page-templates/ConfigLandingPage/DisplayMessageComponents/EnterEventConfirmationSection';
import InviteOnlyNoAccessSection from '@/components/landing-page-templates/ConfigLandingPage/DisplayMessageComponents/InviteOnlyNoAccessSection';
import GuestAccountPromptLogout from '@/components/landing-page-templates/ConfigLandingPage/DisplayMessageComponents/GuestAccountPromptLogout';
//utils
import { _isUndefined, _isEmpty as _isEmptyObj } from '@/utils/jsHelpers/obj';
import NewLandingPageCountdownTimer from '@/components/NewLandingPageCountdownTimer';
import { useMediaQuery } from 'react-responsive';
import { makeIsEventPriorCheckInAccess } from '@/models/event';
import classnames from 'classnames';

const CheckinValidation = ({
  event,
  currentUserEventPermissions,
  currentUser,
  landingPageObject,
  isEventLive,
  isEventDone,
  isEventBefore,
  eventRoleId,
  isEmbedView = false,
  isSpeakerPage,
  isLoginFlowOnly = false,
}) => {

  const dispatch = useDispatch();

  const {
    formBgColour = '#081529',
    formFontColour = '#FFFFFF',
    eventEntryType,
  } = landingPageObject;

  const buttonBgColor: string =
    formBgColour === '#000000' ? '#353535' : formBgColour;

  const buttonStyle: ILandingPageButtonStyle = {
    backgroundColor: buttonBgColor,
    color: formFontColour,
  };

  const isEventPriorCheckInAccess = useSelector(makeIsEventPriorCheckInAccess);
  useEffect(() => {
    const eventId = event.eventId;
    if (isEventPriorCheckInAccess === null) {
      dispatch({
        type: 'event/getIsEventPriorCheckInAccess',
        payload: { eventId },
      });
    }
  }, [event, isEventPriorCheckInAccess]);

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const isInviteOnlyAccess = isEventBefore && (eventEntryType === IEventCheckinType.INVITE_ONLY && !isSpeakerPage);
  const isBeforeEvent = isEventBefore && eventRoleId && (eventEntryType !== IEventCheckinType.INVITE_ONLY || isSpeakerPage);
  const isBeforeEvent_DirectCheckin = isEventBefore && eventEntryType === IEventCheckinType.DIRECT_CHECKIN;

  // Prompt a guest account to logout if at an attendee landing page for another
  //  event. (Guest account can only sign up for one event.)
  const showGuestLogoutScreen: boolean =
    currentUser.isGuestAccount && _isEmptyObj(currentUserEventPermissions);

  //Scenario when attendee logged in to other event and tries to access invite only event
  //show Invite Only event message upfront when page load.
  const showInviteOnlyEventScreen: boolean =
      currentUser?.accountId && _isEmptyObj(currentUserEventPermissions) && eventEntryType === IEventCheckinType.INVITE_ONLY;

    const timerBoxContainerClasses = classnames(styles.timerBoxContainer, {
      [styles.timerBoxContainerBottomFixed]: !isEmbedView,
    });

  return (
    <div
      className={classnames(styles.mainContainer, {
        [styles.embedMainContainer]: isEmbedView,
      })}
    >
      {isBeforeEvent && !isEventPriorCheckInAccess &&
        <BeforeEventSection
          event={event}
          currentUserEventPermissions={currentUserEventPermissions}
          landingPageObject={landingPageObject}
        />
      }

      {/* Before Event Start entry for event Organizers */}
      {isBeforeEvent && isEventPriorCheckInAccess &&
        <EnterEventConfirmationSection
          buttonStyle={buttonStyle}
          currentUser={currentUser}
          currentUserEventPermissions={currentUserEventPermissions}
          event={event}
          isEmbedView={isEmbedView}
          isLoginFlowOnly={isLoginFlowOnly}
        />
      }

      {isBeforeEvent_DirectCheckin &&
        <BeforeEventSection
          event={event}
          currentUserEventPermissions={currentUserEventPermissions}
          landingPageObject={landingPageObject}
        />
      }

      {isEventDone &&
        <AfterEventSection buttonStyle={buttonStyle} />
      }


      {isEventLive && !showGuestLogoutScreen && !showInviteOnlyEventScreen &&
        <EnterEventConfirmationSection
          buttonStyle={buttonStyle}
          currentUser={currentUser}
          currentUserEventPermissions={currentUserEventPermissions}
          event={event}
          isEmbedView={isEmbedView}
          isLoginFlowOnly={isLoginFlowOnly}
        />
      }


      {isInviteOnlyAccess &&
        <BeforeEventSection
          event={event}
          currentUserEventPermissions={currentUserEventPermissions}
          landingPageObject={landingPageObject}
        />
      }

      {showInviteOnlyEventScreen &&
        <InviteOnlyNoAccessSection
          currentUser={currentUser}
        />
      }

      {showGuestLogoutScreen &&
        <GuestAccountPromptLogout
          currentUser={currentUser}
          buttonStyle={buttonStyle}
        />
      }
      {isMobile && isEventBefore && !isEmbedView && (
        <div className={timerBoxContainerClasses}>
          <div className={styles.timerBox}>
            <NewLandingPageCountdownTimer />
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckinValidation;
